module.exports = __webpack_public_path__ + "static/media/logo-white.f6918e9b.svg";